// removed by extract-text-webpack-plugin
module.exports = {"img":"_29gAi"};